<template lang="pug">
#customers-details.scroll-y.grid-con.full-a
	.selected-account
		.details: .account-info: .contact-info
			.name
				.label Name
				.data(type="text") {{ name }}
			.email
				.label Email
				.data(type="text") {{selection?.email || " "}}
			.phone
				.label Phone
				.data(type="text") {{selection?.phone || " "}}
			.phone
				.label Postal Code
				.data(type="text") {{selection?.postalCode || " "}}
			.discount
				.label Discount
				.data {{ discountStatus || 'None' }}

		.account-activity-container
			//- DOGS -//
			Dropdown.full-width(:is-open="openDropdown === 'dogs'" @open="openDropdown = 'dogs'" @close="openDropdown = undefined")
				template(#header) Customer Dogs
				template(#default): .dog-list: DogCard(
					v-for="dog in dogs.asArray.filter(d => d.owner === selection.$id)"
					:key="dog.$id"
					:dog="dog"
					@click="editDog=dog.$id"
				)
			//- NOTES -//
			Dropdown.full-width(
				:is-open="openDropdown === 'notes'"
				@open="openDropdown = 'notes'"
				@close="openDropdown = undefined"
			)
				template(#header) Notes
				template(#default): UserNotesPanel(:uid="selection.$id")
			//- CONTRACTS -//
			Dropdown.full-width(
				:is-open="openDropdown === 'contracts'"
				@open="openDropdown = 'contracts'"
				@close="openDropdown = undefined"
			)
				template(#header) Contracts
				template(#default)
					.contract-list
						template(v-if="userAgreements.length")
							.contract-detail(
								v-for="agreement in userAgreements"
								:key="agreement.$id"
								@click="openDocusignEnvelope(agreement.$id, agreement.dsEnvelopeStatus)"
							)
								.data-key Name
								.data-value {{ dogs.dogs[agreement.specifiers?.dogId || '']?.name || "Unknown" }}
								.data-key Training
								.data-value {{getTrainingType(agreement?.specifiers?.requestId || '')}}
								.contract-status Contract
									.status.green(v-if="agreement.dsEnvelopeStatus === 'completed'") Signed
									.status.red(v-else) {{agreement.dsEnvelopeStatus}} - {{agreement.status}}
						.contract-detail-null(v-if="!userAgreements.length") This user has no user contracts
					.error(v-if="error") {{ error }}
					.loading(v-if="loading.type === 'opening-contract'") Opening in new tab...
					//- .loading(v-if="(loading.type==='opening-contract')") Opening in new tab...
			//- TRANSACTIONS -//
			Dropdown.full-width(
				:is-open="openDropdown === 'transactions'"
				@open="openDropdown = 'transactions'"
				@close="openDropdown = undefined"
			)
				template(#header) Invoices
				template(#default)
					h3.heading 
					ul.scroll-y
						li(
							v-for="invoice in invoiceStore.asArray"
							:key="invoice.invoiceId"
						)
							.transaction-container
								.inv-data.total
									.label Amount
									.req-val $ {{ invoice.totalAmount }}
								.inv-data.description
									.label Description
									.req-val {{ invoice.description }}
								.inv-data.due
									.label Due Date
									.req-val {{ moment(invoice.dueAt).format("ddd, MM/DD/YY, h:mm a") || "-" }}
								.inv-data.options
									button(@click="invOpenSet.has(invoice.$id) ? invOpenSet.delete(invoice.$id) : invOpenSet.add(invoice.$id)")
										include ../resources/icons/options.svg
								.transaction-options(v-if="invOpenSet.has(invoice.$id)")
									.options-container
										table.transaction-table(cellpadding="0" cellspacing="0" border="0")
											thead  
												th Amount 
												th Initiated 
												th Est. Arrival 
												//- th 
												th
											InvoiceTransactions(:stripe-ids="invoice.stripePaymentIds || []")

	Modal(v-if="editDog" @close="editDog = undefined")
		DogCreator(:edit-dog="editDog" @close="editDog = undefined")

</template>

<script lang="ts" setup>
import { DataInstance } from '@busy-human/gearbox';
import Modal from '@/components/Modal.vue';
import DogCreator from '@/components/dog-creator.vue';
import { Events, Userspaces } from '@busy-human/k9-library';
import { ref, computed, onUpdated, watch } from 'vue';
import DogCard from './dog-card.vue';
import Dropdown from './dropdown.vue';
import { useDogspace } from '@/store/dogspaces';
import UserNotesPanel from './user-notes-panel.vue';
import { getAgreementUrl, testAddCustomer } from '@/util/functions';
import { useAgreements } from '@/store/useAgreements';
import { useScheduleRequests } from '@/store/useScheduleRequests';
import { useInvoices } from '@/store/useInvoices';
import { storage } from '@/util/firebase';
import { ref as storageRef, getDownloadURL } from 'firebase/storage';
import moment from "moment";
import InvoiceTransactions from './invoice-transactions.vue';

const props = defineProps<{ selection: DataInstance<Userspaces.Model> }>();

const dogs = useDogspace();
const agreements = useAgreements();
const requestStore = useScheduleRequests();
const invoiceStore = useInvoices();
const error = ref<string | null>(null);
const loading = ref({ status: false, type: "" });
const editDog = ref<string>();

const invOpenSet = ref(new Set<string>());

const openDropdown = ref<'dogs' | 'notes' | 'contracts' | 'transactions'>();

const userAgreements = computed(
	() =>
		agreements.asArray.filter(r => r.uids.includes(props.selection.$id))
);
const discountStatus = computed(() => props.selection.discountQualifier);
const name = computed(() => {
	console.log(" %c NAME: ", "outline:1px solid yellow;color:yellow;background-color:black;", props.selection.name);
	if (typeof props.selection?.name === "object") {
		if (props.selection?.name?.fullName?.length) {
			return props.selection?.name?.fullName;
		} else {
			return `${props.selection?.name?.firstName || " "} ${props.selection?.name?.lastName || " "}`;
		}
	} else if (typeof props.selection?.name === "string") {
		return props.selection.name;
	} else {
		return "unknown";
	}
});

const openDocusignEnvelope = async (agreementId: string, status: string) => {
	if (status !== "completed") {
		error.value = "Cannot open incomplete contract";
		return;
	}
	loading.value = { status: true, type: "opening-contract" };
	// console.log("HERE:", agreementId)
	error.value = null;
	const agreement = agreements.requests.get(agreementId);
	if (agreement) {
		console.log("Agreement", agreement);
		
		try {
			let agreementUrl = '';
			if(agreement?.pdfUrl){
				const fileRef = storageRef(storage, agreement?.pdfUrl);

				agreementUrl = await getDownloadURL(fileRef);
			}else{
				const data = await getAgreementUrl({ agreementId: agreement.$id, isSender: true });

				agreementUrl = data.data.url;
			}

			if(!agreementUrl) throw new Error('Unable to access contract');
			window.open(agreementUrl, '_blank');
			loading.value = { status: false, type: "" };
			
		} catch (e) {
			error.value = "Unable to access Contract";
			loading.value = { status: false, type: "" };
		}

	}
	// console.log("HERE 2:", loading.value)
	// loading.value = false;
};


const getTrainingType = (requestId: string) => {
	const request = requestStore.requests.get(requestId);
	if (!request) return null;
	if ('trainingType' in request) {
		return Events.TrainingTypeMap[request.trainingType];
	} else {
		return null;
	}
};

watch(() => props.selection, () => {
	invoiceStore.fetchUserInvoices(props.selection.$id);
});
</script>

<style lang="scss">
#customers-details {
	padding: 0 1rem;

	.dropdown.full-width {
		width: 100%;
	}

	.selected-account {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding: 2rem;
	}

	.selected-account .details {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.selected-account .details .account-info,
	.selected-account .details .invoice-info {
		display: flex;
		width: clamp(400px, 40%, 1000px);
		height: clamp(600px, 100%, 1000px);

		.contact-info {
			display: flex;
			flex-direction: column;
			gap: 0.7rem;
			width: 100%;
			padding: 1rem;
		}

		.contact-info>div {
			box-sizing: border-box;
			width: 100%;
			height: 80px;
			padding: 0.5rem 1rem;
			background-color: $color-white;
			border: 1px solid $color-black;
			box-shadow: 2px 2px 0 $color-black;
		}

		.label {
			color: $color-gray-62;
		}

		.contact-info .data {
			overflow: hidden;
			font-size: 1.2rem;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.contact-info select {
			width: 100%;
			border: unset;
		}
	}

	.account-actions {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	.account-activity-container {
		display: flex;
		flex-direction: column;
		gap: .5rem;
		width: 100%;
		margin-top: 2%;
	}

	.dog-list {
		display: grid;
		grid-auto-flow: column;
		gap: .5rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
		overflow-x: auto;
	}

	.contract-list {
		display: grid;
		grid-auto-columns: 17rem;
		grid-auto-flow: column;
		gap: 1rem;
	}

	.contract-detail {
		display: grid;
		grid-template-columns: min-content auto;
		gap: 0 .5rem;
		padding: 1rem;
		margin-top: 1rem;
		font-size: .9em;
		font-weight: 100;
		cursor: pointer;
		border: 1px solid $color-black;
		border-radius: 1rem;
		box-shadow: 2px 2px 0 $color-black;

		.data-value {
			font-size: 1.1em;
			font-weight: 400;
		}

		.contract-status {
			grid-column: 1 / -1;
			padding: .5rem;
			margin-top: 1rem;
			text-transform: capitalize;
			border: 1px solid $color-gray-62;
			border-radius: .5rem;
		}

		.contract-status .green,
		.contract-status .red {
			font-size: 1.2em;
			color: $color-green;
		}

		.contract-status .red {
			color: $color-red;
		}
	}

	.contract-detail-null {
		width: 100%;
		padding: 2rem;
	}

	.transaction-container {
		// display: flex;
		// justify-content: space-between;
		display: grid;
		grid-template-columns: 1fr 2fr .75fr .1fr;
		grid-auto-flow: dense;
		grid-gap: 1rem;
		margin: 1em 0;
		overflow: hidden;
		border: 1px solid #000013;
		border-radius: 1rem;
		box-shadow: 2px 2px 0 #000013;

		.inv-data {
			padding: 1em;
		}

		/* stylelint-disable-next-line no-descending-specificity */
		.label {
			font-weight: 300;
			color: #666;
		}

		button {
			background-color: transparent;
		}
	}

	.options-container {
		display: flex;
		align-items: center;
		width: 100%;

		button {
			margin: .5em;
		}

		button:hover {
			background-color: black;
		}
	}

	.transaction-options {
		grid-column: 1 / -1;
	}

	.transaction-table {
		width: 100%;

		table, td {
			border-spacing: 0;
			border-collapse: collapse;
		}

		th {
			padding: .5rem 1em;
			font-weight: 100;
			color: rgba(0 0 0 / 60%);
		}

		td {
			padding: 1rem 1em;
		}

		tr:nth-child(even)  td {
			background: #F4F4F4;
		}
	}
}
</style>